module.exports = __webpack_public_path__ + "static/media/0.0503ac92.jpg";